export default "__VITE_ASSET__DPFHKo7k__"